"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'microphone.access.denied': '麦克风访问被拒绝。请允许麦克风访问以使用语音功能。',
};
